import {Model} from '../base.model';

export class InvoicePaymentMethod extends Model {
    name: string;
}
